import announcementApi from "@/api/announcements";

// fetchUnreadAnnouncementCount の発行順序を追跡し、古い in-flight レスポンスが
// 新しいレスポンスを上書きしないようにする（最後にスタートしたフェッチのみが state を更新する）。
let unreadFetchSeq = 0;

export default {
  namespaced: true,
  state: () => ({
    slugName: '',
    facilities: [],
    facilityIndex: 0,
    activeMenu: 'list',
    userData: {},
    unreadAnnouncementCount: 0
  }),
  getters: {
    facility ({ facilities, facilityIndex }) {
      return facilities[facilityIndex];
    },
    permissions ({ userData }) {
      if (typeof userData.user_permissions === "undefined") {
        return [];
      }
      return userData.user_permissions;
    },
    userData (state) {
      return state.userData;
    }
  },
  mutations: {
    update_facilities (state, payload) {
      state.facilities = payload;
    },
    update_active_menu (state, payload) {
      state.activeMenu = payload;
    },
    update_userdata (state, payload) {
      state.userData = payload;
    },
    set_unread_count (state, count) {
      state.unreadAnnouncementCount = Math.max(0, Number(count) || 0);
    },
    decrement_unread_count (state) {
      state.unreadAnnouncementCount = Math.max(0, state.unreadAnnouncementCount - 1);
    }
  },
  actions: {
    updateFacilities ({ commit }, payload) {
      commit('update_facilities', payload)
    },
    updateActiveMenu ({ commit }, payload) {
      commit('update_active_menu', payload)
    },
    updateUserData ({ commit }, payload) {
      commit('update_userdata', payload)
    },
    async fetchUnreadAnnouncementCount ({ commit }) {
      const seq = ++unreadFetchSeq;
      try {
        const { data } = await announcementApi.getUnreadCount();
        // 後発のフェッチが既に走っている場合、こちらの応答は古いので破棄する。
        if (seq !== unreadFetchSeq) return;
        commit('set_unread_count', data?.count ?? 0);
      } catch (e) {
        // 失敗時は静かに無視（バッジ非表示維持）
      }
    }
  }
}
